import { useTranslation } from "@coworker/locales";
import FixaSSRIcon from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import InformationCircleIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/InformationCircleIconPath";
import styles from "./task-notification.module.css";

const TaskNotificationPriority = () => {
  const { t } = useTranslation();
  return (
    <div className={styles["task-notification-item-body-priority"] ?? ""}>
      <FixaSSRIcon paths={InformationCircleIconPath} />
      {t("priorityString")}
    </div>
  );
};

export default TaskNotificationPriority;
